<template>
  <div class="app-container">
    <RouterView />
    <Toast position="bottom-right"></Toast>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Toast from 'primevue/toast';
import { useRouter } from 'vue-router'
const router = useRouter()
import { useUsers } from "@/features/users/controller";
const $userStore = useUsers();

const init = async () => {
  // if ($userStore.loggedUser) {
  //   await $userStore.getUser();
  // }
}
init();
</script>